import * as React from 'react';

// MDX component for `<YouTube youTubeId="..." />` used in articles.
export const YouTube = ({
  youTubeId,
  title = 'CopingCard video',
  aspectRatio = '16 / 9',
  maxWidth,
}: {
  youTubeId: string;
  title?: string;
  aspectRatio?: string;
  maxWidth?: number | string;
  /** Language of the film when it differs from the page's (a Russian page that embeds the English film): read by gatsby-node for the VideoObject's inLanguage; not rendered. */
  lang?: 'en' | 'ru';
}) => (
  <div
    style={{
      position: 'relative',
      aspectRatio,
      maxWidth,
      marginLeft: maxWidth ? 'auto' : undefined,
      marginRight: maxWidth ? 'auto' : undefined,
      borderRadius: 20,
      overflow: 'hidden',
      margin: '24px 0',
      boxShadow: 'var(--ss-shadow-md)',
    }}
  >
    <iframe
      src={`https://www.youtube.com/embed/${youTubeId}`}
      title={title}
      loading="lazy"
      style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    />
  </div>
);

export default YouTube;
